import { FC, memo } from "react";
import LoyaltyCardRank, {
  LoyaltyCardRankProps,
} from "components/molecules/LoyaltyCardRank";
import { useFormatCardsReward } from "hooks/useFormatCardsReward";
import { useLocation, useNavigate } from "react-router-dom";
import { GET_POPUP_TYPES } from "constants/popupConfig";
import url from "../../url";

type LoyaltyCardRankContainerProps = LoyaltyCardRankProps & {
  canLoadInfo: boolean;
};

const LoyaltyCardRankContainerComponent: FC<LoyaltyCardRankContainerProps> = (
  props,
) => {
  const { nameRank, level = undefined } = props;
  const location = useLocation();
  const navigate = useNavigate();
  const { image, isLoading, allRewardsIsGetting } = useFormatCardsReward(
    props?.nameRank,
    props?.level,
    props?.canLoadInfo,
  );

  const onHandleClickButtonCard = () => {
    if (level) {
      if (props?.userExperience >= props?.rankExperience) {
        navigate(
          `${location.pathname}?popup=${GET_POPUP_TYPES.popup.rewardsLevelCompleted}&name=${nameRank}&level=${level}&isComplete=1`,
          { replace: false },
        );
      } else {
        navigate(
          `${location.pathname}?popup=${GET_POPUP_TYPES.popup.rewardsLevel}&name=${nameRank}&level=${level}&isComplete=2`,
          { replace: true },
        );
      }
      return;
    }
    navigate(url.routes.profile.loyaltyProgramRanks());
  };

  return (
    <LoyaltyCardRank
      {...props}
      image={image}
      isLoading={isLoading}
      handleClick={onHandleClickButtonCard}
      allRewardsIsGetting={allRewardsIsGetting}
    />
  );
};

export const LoyaltyCardRankContainer = memo(LoyaltyCardRankContainerComponent);
